import { useState, useEffect } from 'react';

const QUERIES = {
  mobile: '(max-width: 768px)',
  tablet: '(max-width: 1024px)',
};

function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, [query]);

  return matches;
}

/** ≤768px — phone layout with bottom nav + drawer */
export function useIsMobile() {
  return useMediaQuery(QUERIES.mobile);
}

/** ≤1024px — tablet; sidebar collapsed by default */
export function useIsTablet() {
  return useMediaQuery(QUERIES.tablet);
}
